import { Injectable } from '@angular/core'
import { BaseConfigService } from '@engineering11/config-web'
import { CnectConfig } from '../config'

@Injectable({ providedIn: 'root' })
export class ConfigService extends BaseConfigService<CnectConfig> {}
